import useResponsive from '../../../hooks/useResponsive';
import MenuPopover from '../../../components/menu-popover/MenuPopover';
import { Dialog, DialogContent } from '../../../components/ui/Dialog';
import { ReservationGeneral } from '../../../models/owner-portal/reservationGeneral';
import ReservationDetails from '../../dashboard/reservation/ReservationDetails';
import { useReservationPopoverState } from '../../dashboard/reservation/list/useReservationPopoverState';

interface ReservationDetailsPopoverI {
  popoverState: ReturnType<typeof useReservationPopoverState>;
  reservation: ReservationGeneral;
}

export default function ReservationDetailsPopover(props: ReservationDetailsPopoverI) {
  const { popoverState, reservation } = props;
  const isMdUp = useResponsive('up', 'md');

  const detailsContent = (
    <ReservationDetails reservation={reservation} {...popoverState} />
  );

  if (!isMdUp) {
    return (
      <Dialog
        open={!!popoverState.selectedRow}
        onOpenChange={(open) => !open && popoverState.setSelectedRow(null)}
      >
        <DialogContent className="flex h-dvh max-h-dvh flex-col overflow-hidden p-4 sm:h-auto sm:max-h-[90dvh] sm:max-w-lg sm:rounded-lg sm:p-6">
          {detailsContent}
        </DialogContent>
      </Dialog>
    );
  }

  return (
    <MenuPopover
      open={popoverState.selectedRow}
      onClose={() => popoverState.setSelectedRow(null)}
      arrow="left-center"
      contentClassName="min-w-80 w-auto"
    >
      {detailsContent}
    </MenuPopover>
  );
}
